import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconCopy = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M15.0962 29.1666C14.2543 29.1666 13.5417 28.875 12.9583 28.2916C12.375 27.7083 12.0833 26.9957 12.0833 26.1537V7.17954C12.0833 6.3376 12.375 5.62496 12.9583 5.04163C13.5417 4.45829 14.2543 4.16663 15.0962 4.16663H29.0704C29.9124 4.16663 30.625 4.45829 31.2083 5.04163C31.7917 5.62496 32.0833 6.3376 32.0833 7.17954V26.1537C32.0833 26.9957 31.7917 27.7083 31.2083 28.2916C30.625 28.875 29.9124 29.1666 29.0704 29.1666H15.0962ZM15.0962 26.6666H29.0704C29.1987 26.6666 29.3162 26.6132 29.4229 26.5062C29.5299 26.3995 29.5833 26.282 29.5833 26.1537V7.17954C29.5833 7.05121 29.5299 6.93371 29.4229 6.82704C29.3162 6.7201 29.1987 6.66663 29.0704 6.66663H15.0962C14.9679 6.66663 14.8504 6.7201 14.7437 6.82704C14.6368 6.93371 14.5833 7.05121 14.5833 7.17954V26.1537C14.5833 26.282 14.6368 26.3995 14.7437 26.5062C14.8504 26.6132 14.9679 26.6666 15.0962 26.6666ZM9.26292 35C8.42097 35 7.70833 34.7083 7.125 34.125C6.54167 33.5416 6.25 32.829 6.25 31.987V10.5129H8.75V31.987C8.75 32.1154 8.80347 32.2329 8.91042 32.3395C9.01708 32.4465 9.13458 32.5 9.26292 32.5H25.7371V35H9.26292Z"
        fill="#01000B"
      />
    </Svg>
  );
};
